import { FC, useContext } from 'react';
import { generatePath, Navigate, useParams } from 'react-router';

import { useCan } from '~/core/shared/hooks/useCan';
import { TenantDocumentRouteProps } from '../../../config';
import { DocumentDetailsViewContext } from '../Details.view';

type RouterTabProps = {
  //
} & TenantDocumentRouteProps;

export const RouterTab: FC<RouterTabProps> = () => {
  const { config: viewConfig } = useContext(DocumentDetailsViewContext);
  const { meetsRequirement } = useCan();

  const firstAccessibleTab = viewConfig.tabs.find(
    (tab) =>
      (!tab.route.permission || meetsRequirement(tab.route.permission)) &&
      !tab.hidden,
  );

  if (!firstAccessibleTab) {
    console.warn(
      'No active tab found. Please check your tenant configuration.',
    );
    return null;
  }

  const tabRoutePath = firstAccessibleTab.route.path;

  if (!tabRoutePath) {
    console.warn('Active tab does not have a route path defined.');
    return null;
  }

  const path = generatePath(tabRoutePath as string, useParams());

  return <Navigate replace to={path} />;
};
